import { IconProps, NocIconGenerator } from '../common';

export const Playground = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Playground',
            path: (
                <>
                    <path
                        d="M8.53846 4.38462V14.0769M15.4615 4.38462V14.0769M3 4.38462H21M4.38462 21V3M19.6154 21V3"
                        stroke="black"
                        strokeLinecap="round"
                    />
                    <path
                        d="M16.1865 14.502C16.268 14.5106 16.3473 14.5508 16.4092 14.6484C16.4554 14.7216 16.4807 14.8116 16.4922 14.9072L16.5 15.0039C16.5034 15.135 16.4848 15.2791 16.4531 15.4238C16.3262 16.0031 15.9556 16.7414 15.5527 17.1758C14.7148 18.0787 13.3375 18.5112 12.0088 18.499L11.7266 18.4961C10.4825 18.4522 9.22976 18.019 8.44727 17.1758C8.04438 16.7414 7.67376 16.0031 7.54688 15.4238C7.53107 15.3516 7.51874 15.2793 7.51074 15.209L7.5 15.0039C7.50341 14.873 7.52927 14.7459 7.59082 14.6484C7.65266 14.5509 7.732 14.5107 7.81348 14.502C7.89956 14.4929 8.01227 14.5151 8.15332 14.5781C9.56744 15.2103 10.6729 15.5492 11.7783 15.5898L12 15.5938C13.1806 15.5927 14.3383 15.2524 15.8467 14.5781C15.9877 14.5151 16.1004 14.4929 16.1865 14.502Z"
                        stroke="black"
                    />
                </>
            ),
        }}
    />
);
